export const commonSession = {
  COMPLETE_SESSION: "seneca/session/COMPLETE_SESSION",
  COMPLETE_MODULE: "seneca/sessionModule/COMPLETE_MODULE",
  COMPLETE_NOTES_ONLY_SESSION: "seneca/session/COMPLETE_NOTES_ONLY_SESSION"
};
